#import "../fragments/sms-drip-sequence-fragment.graphql"

query GetSmsDripSequence($dripSequenceId: ID!) {
    smsDripSequence(id: $dripSequenceId) {
        ...SmsDripSequenceFragment
    }
}
